<script lang="typescript">
  import { CheckCircle, ChevronDown, ChevronLeft } from "svelte-hero-icons";
  import type { LoadedBudgetAndAccounts } from "../accounts";
  import { budgetsAndAccounts } from "../accounts";

  let open = false;
  let showTwoStep = false;

  export let selectedBudget: string | null = null;
  export let selectedAccount: string | null = null;
  export let selectedCurrency: string | null | undefined = null;

  export let blacklistedAccountIds: string[] = [];

  let loadedBudgetAndAccounts: LoadedBudgetAndAccounts;
  let accountName: string | null | undefined;

  $: {
    const b = $budgetsAndAccounts;
    if (b.type === "LOADED") {
      showTwoStep = b.data.length > 1;
      selectedBudget = showTwoStep ? null : b.data[0]?.id || null;
      loadedBudgetAndAccounts = b;
    }
  }

  $: {
    const b = $budgetsAndAccounts;
    if (selectedBudget && selectedAccount && b.type === "LOADED") {
      const budget = b.data.find((a) => a.id === selectedBudget)!;
      selectedCurrency = budget.currency;
      accountName = b.db.accountsById.get(selectedAccount)?.name;
    }
  }

  function goBackToBudgets() {
    selectedBudget = selectedAccount = null;
  }

  function selectBudgetId(ev: MouseEvent) {
    const target = <HTMLButtonElement>ev.currentTarget;
    if (target.dataset.itemId) {
      selectedBudget = target.dataset.itemId;
    }
  }

  function selectAccount(ev: MouseEvent) {
    const target = <HTMLButtonElement>ev.currentTarget;
    if (target.dataset.itemId) {
      selectedAccount = target.dataset.itemId;
    }
    close();
  }

  function isSelected(id: string) {
    return id === selectedAccount;
  }

  function close() {
    open = false;
  }

  function filterAccounts() {
    const b = $budgetsAndAccounts;
    if (!selectedBudget || b.type !== "LOADED") {
      return [];
    }

    return b.db.budgetsById
      .get(selectedBudget!)!
      .accounts.filter((a) => !blacklistedAccountIds.includes(a.id));
  }
</script>

<svelte:window on:click={close} />

<!-- This example requires Tailwind CSS v2.0+ -->
<div class="relative inline-block text-left w-full md:w-72">
  <div>
    <button
      type="button"
      class="inline-flex w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
      aria-haspopup="true"
      aria-expanded={open ? 'true' : 'false'}
      on:click|stopPropagation={() => (open = true)}>
      <span
        class="flex-1 text-left">{accountName || 'Select YNAB Account'}</span>
      <ChevronDown class="-mr-1 ml-2 h-5 w-5" />
    </button>
  </div>

  {#if open && $budgetsAndAccounts.type === 'LOADED'}
    <div
      class="origin-top-left absolute left-0 mt-2 right-0 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
      <slot>
        {#if !selectedBudget && showTwoStep}
          <div
            class="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu">
            {#each loadedBudgetAndAccounts.data as budget}
              <button
                on:click|stopPropagation={selectBudgetId}
                data-item-id={budget.id}
                class="block text-left focus:outline-none w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900"
                role="menuitem">{budget.name}</button>
            {/each}
          </div>
        {:else}
          <div
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu">
            {#if showTwoStep}
              <button
                on:click|stopPropagation={goBackToBudgets}
                class="w-full inline-flex items-center focus:outline-none justify-center align-middle text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900 border-b border-gray-200">
                <span class="h-8 w-8 p-1 mr-4 border-r border-gray-200">
                  <ChevronLeft class="" />
                </span>
                <span class="flex-1 text-left">Back</span>
              </button>
            {/if}
            {#each filterAccounts(loadedBudgetAndAccounts.db.budgetsById.get(selectedBudget || '')?.accounts || []) || [] as account}
              <button
                on:click|stopPropagation={selectAccount}
                data-item-id={account.id}
                class="group w-full inline-flex items-center text-left focus:outline-none text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900"
                role="menuitem">
                <span class="h-8 w-8 p-1 mr-4 border-r border-transparent">
                  <CheckCircle
                    class={isSelected(account.id) ? 'text-indigo-600' : 'text-indigo-50 group-hover:text-indigo-200'} />
                </span>
                <span class="flex-1 text-left">{account.name}</span>
              </button>
            {/each}
          </div>
        {/if}
      </slot>
    </div>
  {/if}
</div>
